import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import {t} from '@client/i18n/localize'

window.CookieConsent = CookieConsent

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";

const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }

window.addEventListener('cc:onModalReady', ({ detail }) => {
  const { modalName, modal } = detail;

  const buttons = {
    "all": "cookiebanner-accept-all",
    "necessary": "cookiebanner-reject-non-essential",
    "save": "cookiebanner-save-settings"
  };

  Object.entries(buttons).forEach(([role, id]) => {
    const button = modal.querySelector(`button[data-role="${role}"]`);
    if (button && !button.id) {
      button.setAttribute("id", id);
    }
  });
});

// Set default consent to 'denied' (this should happen before changing any other dataLayer)
gtag('consent', 'default', {
  [SERVICE_AD_STORAGE]: 'denied',
  [SERVICE_AD_USER_DATA]: 'denied',
  [SERVICE_AD_PERSONALIZATION]: 'denied',
  [SERVICE_ANALYTICS_STORAGE]: 'denied',
  [SERVICE_FUNCTIONALITY_STORAGE]: 'granted',
  [SERVICE_PERSONALIZATION_STORAGE]: 'denied',
  [SERVICE_SECURITY_STORAGE]: 'granted',
});

function updateGtagConsent() {
  gtag('consent', 'update', {
    [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
    [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
    [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
    [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT) ? 'granted' : 'denied',
    [SERVICE_FUNCTIONALITY_STORAGE]: 'granted',
    [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
    [SERVICE_SECURITY_STORAGE]: 'granted'
  });

  if (CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) && window.exponea) {
    exponea.start();
  }
}

$(document).on('turbolinks:load', () => {
  if (window.testMode) {
    return
  }

  CookieConsent.reset()
  CookieConsent.run({
    onConsent: () => {
      updateGtagConsent();
    },
    onChange: () => {
      updateGtagConsent();
    },
    categories: {
      [CAT_NECESSARY]: {
        enabled: true,
        readOnly: true
      },
      [CAT_ANALYTICS]: {
        enabled: true,
        readOnly: false,
        autoClear: {
          reloadPage: true,
          cookies: [
            {
                name: /^_ga/,   // regex: match all cookies starting with '_ga'
            },
            {
                name: '_gid',   // string: exact cookie name
            }
          ]
        },
        services: {
          [SERVICE_ANALYTICS_STORAGE]: {
            label: t('cookieconsent.service_analytics_storage'),
          }
        }
      },
      [CAT_ADVERTISEMENT]: {
        enabled: false,
        readOnly: false,
        autoClear: {
          reloadPage: true,
          cookies: [
            {
              name: /^(__exponea)/, // Bloomreach cookies
            },
            {
              name: /^(xnpe_)/, // Bloomreach cookies
            },
            {
              name: /^(_fbp)/, // Facebook Pixel
            },
            {
              name: /^(_uetsid)/, // Microsoft Bing
            },
            {
              name: /^(_uetvid)/, // Microsoft Bing
            },
            {
              name: /^(_gcl)/, // Google Ads
            }
          ]
        },
        services: {
          [SERVICE_AD_STORAGE]: {
            label: t('cookieconsent.service_ad_storage'),
          },
          [SERVICE_AD_USER_DATA]: {
            label: t('cookieconsent.service_ad_user_data'),
          },
          [SERVICE_AD_PERSONALIZATION]: {
            label: t('cookieconsent.service_ad_personalization'),
          },
        }
      },
      [CAT_FUNCTIONALITY]: {
        services: {
          [SERVICE_FUNCTIONALITY_STORAGE]: {
            label: t('cookieconsent.service_functionality_storage'),
          },
          [SERVICE_PERSONALIZATION_STORAGE]: {
            label: t('cookieconsent.service_personalization_storage'),
          },
        }
      },
      [CAT_SECURITY]: {
        services: {
          [SERVICE_SECURITY_STORAGE]: {
            label: t('cookieconsent.cat_security'),
          },
        }
      }
    },

    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'middle center',
        equalWeightButtons: true
      }
    },
    disablePageInteraction: true,
    language: {
      default: window.LOCALE,
      translations: {
        [window.LOCALE]: {
          consentModal: {
            title: t('cookieconsent.consent_modal.title'),
            description: t('cookieconsent.consent_modal.description'),
            acceptAllBtn: t('cookieconsent.accept_all'),
            acceptNecessaryBtn: t('cookieconsent.reject_all'),
            showPreferencesBtn: t('cookieconsent.consent_modal.show_preferences'),
          },
          preferencesModal: {
            title: t('cookieconsent.preferences_modal.title'),
            acceptAllBtn: t('cookieconsent.accept_all'),
            acceptNecessaryBtn: t('cookieconsent.reject_all'),
            savePreferencesBtn: t('cookieconsent.preferences_modal.save_preferences'),
            sections: [
              {
                title: '',
                description: t('cookieconsent.preferences_modal.section_header.description'),
              },
              {
                title: t('cookieconsent.preferences_modal.functional.title'),
                description: t('cookieconsent.preferences_modal.functional.description'),
                linkedCategory: 'necessary'
              },
              {
                title: t('cookieconsent.preferences_modal.analytics.title'),
                description: t('cookieconsent.preferences_modal.analytics.description'),
                linkedCategory: 'analytics'
              },
              {
                title: t('cookieconsent.preferences_modal.marketing.title'),
                description: t('cookieconsent.preferences_modal.marketing.description'),
                linkedCategory: 'advertisement'
              },
              {
                title: t('cookieconsent.preferences_modal.section_footer.title'),
                description: t('cookieconsent.preferences_modal.section_footer.description_html'),
              }
            ]
          }
        }
      }
    },
  });
})
